import * as React from "react";
import { WithStyles, withStyles, createStyles, Theme } from 'components/controls/styles';
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import { withActionsExecutor, ActionsExecutorPropsType, Action, ActionError } from "components/actions";
import { Grid, Typography } from "components/controls/widget";
import { hasFlag } from "components/state/types";
import rootPath, { RouteProps } from "./routes-path";

import PageTitle from "common/web/PageTitle";
import PageHeader from "common/web/PageHeader";


import pathPrestupy from "./prestupy/routes-path";

import pathSoutezniUdaje from "./soutezni-udaje/routes-path";
import pathUpajeOp from "./udaje-op/routes-path";
import pathAnketyHlasovani from "./ankety-a-hlasovani/routes-path";
import pathPrispevky from "./prispevky/routes-path";


import Prestupy from "./prestupy/Prestupy";

import { OsobniUdaje } from "./osobni-udaje/view";
import SoutezniUdaje from "./soutezni-udaje/SoutezniUdaje";
import UpajeOp from "./udaje-op/UpajeOp";
import AnketyHlasovani from "./ankety-a-hlasovani/AnketyHlasovani";
import Prispevky from "./prispevky/Prispevky";

import SideMenu from "./SideMenu";

import Loading from "common/components/controls/Loading";
import Error from "common/components/controls/Error";

import { MemberValidationState } from "../../../../member-validation/entity";
import { useMemberDetail } from "./store";
import { useUIContext } from "../../../../context/store";
import { useMemberValidation } from "../../../../member-validation/store";

type Props = RouteComponentProps<RouteProps> & WithStyles<typeof styles>;


const styles = (theme: Theme) => createStyles({
    grow: {
        flexGrow: 1,
    },
});

const HeaderContent = () => {

    const [{ entity, initialized, isSecretary }] = useMemberDetail();
    const [memberValidationState, { getValidationState, invalidateValidationCache }] = useMemberValidation();
    const [contextState, { loadMember }] = useUIContext();
    const validationState = memberValidationState.entity.state;

    React.useEffect(() => {
        if (initialized && entity) {
            loadMember(entity.idtClena);
        }
    }, [initialized]);


    React.useEffect(() => {
        if (contextState.memberLoaded && entity && contextState.data.member) {
            invalidateValidationCache();
        }

    }, [contextState.memberLoaded]);

    React.useEffect(() => {
        getValidationState(entity?.idtClena);
    }, [memberValidationState.dataValid, entity?.idtClena]);

    const userAndMemberIdtEquals = contextState.data.member.userMemberIdt === entity?.idtClena;

    const emailValid = hasFlag(validationState, MemberValidationState.EmailValid);
    const phoneValid = hasFlag(validationState, MemberValidationState.PhoneValid);

    const showValidationMessage = (!emailValid || !phoneValid) && userAndMemberIdtEquals;

    const emailPhoneText = !emailValid && !phoneValid ? "emailu a telefonu" : !emailValid ? "emailu" : "telefonu";

    return <>
        <Typography variant="h5">{`${entity?.prijmeni} ${entity?.jmeno}, IDT ${entity?.idtClena}`}</Typography>
        {showValidationMessage && <Typography variant="subtitle1" color="error">{`Nejste ověřený člen ČSTS. Prosíme, dokončete ověření svého ${emailPhoneText} ve spolupráci se sekretariátem.`}</Typography>}
    </>
}


const View = (props: Props) => {

    const { classes, match } = props;
    const { idtClena } = match.params;

    const [{ entity, loading, loadFailure, errors }, { loadMemberData }] = useMemberDetail();

    React.useEffect(() => {
        loadMemberData(Number(idtClena))
    }, []);


    const showDetail = !loading && !loadFailure && entity != null;

    return <div>
        <PageTitle title="Detailní údaje člena" />
        <PageHeader>
            {loading
                ? <Loading loading={loading} color="primary" />
                : loadFailure
                    ? <Error>{errors[""].errors}</Error>
                    : <HeaderContent />
            }
        </PageHeader>

        {showDetail && <Grid container direction="row" justify="flex-end" wrap="nowrap">
            <Grid item className={classes.grow}>
                <Switch>
                    <Route path={rootPath} exact render={() => <OsobniUdaje />} />
                    <Route path={pathPrestupy} render={() => <Prestupy clenId={entity.id} userAccess={entity.userAccess} />} />
                    <Route path={pathSoutezniUdaje} render={() => <SoutezniUdaje senior={entity.senior} clenId={entity.id} />} />
                    <Route path={pathUpajeOp} render={() => <UpajeOp clenId={entity.id} />} />
                    <Route path={pathAnketyHlasovani} render={() => <AnketyHlasovani />} />
                    <Route path={pathPrispevky} render={() => <Prispevky idtClena={entity.idtClena} />} />
                    <Redirect to={rootPath} />
                </Switch>
            </Grid>
            <Grid item>
                <SideMenu />
            </Grid>
        </Grid>
        }

    </div >
}

const DecoratedView = withRouter(withStyles(styles)(View));

export {
    DecoratedView as DetailClena
}